import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";

export const Route = createFileRoute("/politica-de-reembolso")({
  head: () => ({
    meta: [
      { title: "Política de reembolso — Viny Club" },
      {
        name: "description",
        content: "Conheça nossa política de reembolso para assinaturas e compras na Viny Club.",
      },
    ],
  }),
  component: PoliticaDeReembolso,
});

function PoliticaDeReembolso() {
  return (
    <AppShell>
      <PageHeader
        eyebrow="Transparência"
        title="Política de reembolso"
        subtitle="Nosso compromisso com você."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 lg:px-8">
        <article className="space-y-8 text-foreground/90">
          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">1. Assinaturas Premium</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Oferecemos um período de teste gratuito para novos usuários do plano Premium. Após a cobrança, você pode solicitar reembolso integral dentro de <strong>7 dias corridos</strong> da primeira cobrança, desde que não tenha utilizado benefícios exclusivos de forma abusiva.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">2. Renovações automáticas</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              As assinaturas são renovadas automaticamente no final de cada ciclo de cobrança. Você pode cancelar a qualquer momento nas configurações da conta. O cancelamento interrompe a renovação, mas não gera reembolso proporcional do período já pago, exceto nos casos previstos na lei.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">3. Compras no Marketplace</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Transações de discos entre usuários são regidas pelas regras do vendedor e pelas condições do produto anunciado. A Viny Club funciona como intermediadora da plataforma e não se responsabiliza por defeitos não declarados. Em caso de divergência, entre em contato com o suporte em até <strong>48 horas</strong> após o recebimento.
            </p>
          </section>

          <section>
            <h2 className="mb-2 font-display text-lg font-semibold">4. Como solicitar</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Envie um e-mail para <strong>suporte@viny.club</strong> com o assunto "Solicitação de reembolso", informando o e-mail da conta, data da cobrança e motivo. Analisamos cada caso em até 5 dias úteis.
            </p>
          </section>

          <p className="text-xs text-muted-foreground">
            Última atualização: {new Date().getFullYear()}.
          </p>
        </article>
      </div>
    </AppShell>
  );
}
